import { render, staticRenderFns } from "./CourseInstructions.vue?vue&type=template&id=75e508e2"
import script from "./CourseInstructions.vue?vue&type=script&lang=js"
export * from "./CourseInstructions.vue?vue&type=script&lang=js"
import style0 from "./CourseInstructions.vue?vue&type=style&index=0&id=75e508e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports